import React, { Component } from 'react';
import { ErrorBoundaryProps, ErrorBoundaryState } from './error-boundary.props';
import { Text } from 'common/common-components.styled';

export class ErrorBoundaryComponent extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    this.props.hideOverlay();
    this.setState({ hasError: true });

    const message = (error && error.message) || '';
    const shouldReload =
      /loading chunk \d+ failed/i.test(message) ||
      /chunkloaderror/i.test(message) ||
      /failed to fetch dynamically imported module/i.test(message) ||
      /importing a module script failed/i.test(message);

    if (shouldReload) {
      const reloadFlagKey = 'reloadedDueToDynamicImportError';
      const alreadyReloaded = sessionStorage.getItem(reloadFlagKey) === 'true';
      if (!alreadyReloaded) {
        sessionStorage.setItem(reloadFlagKey, 'true');
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.errorComponent || (
          <Text size='24' bold left='30'>
            Error
          </Text>
        )
      );
    }
    return this.props.children;
  }
}
